/*!
 * JM Live Preview v1.9.6 add-on — several charms on one chain, built from the month photos
 * (Carré, Éclat, Solitaire Bezel, Grace Solitaire …). Switched on per product in metafield
 * "Live preview: split settings" (custom.preview_split): {"hang": {}}
 * Optional (charm widths unless noted): gap 1.2 (space between charm centres), turn 0.6 (0–1, how much the
 * charms fan out with the curve), minR 1.6 (smallest curve radius), lift (bail overlap, chain widths), threshold (background tolerance).
 * mode: "v" = charms hang straight down, close together, chain redrawn from whole links (Grace);
 *       "row" = round bezels joined side by side in a soft curve (Solitaire Bezel). fill / bailUp / curve tune them.
 *
 * How it works: each month photo is read once. The charm is cut out (holes such as a clear April stone are
 * kept, nothing is lost along the edges), the photo's chain is traced and its two sides fitted with straight
 * lines. For 2+ charms the bottom of the chain becomes a curve that meets both sides smoothly (a circle
 * touching both lines); the chain along that curve is copied from the photo's own links, and the charms
 * hang side by side along it, fanning slightly like a real necklace.
 */
(function () {
  'use strict';
  var JM = window.JMLivePreview;
  if (!JM || !JM._tools || JM._chainAddon) return;
  JM._chainAddon = 2;
  var P = JM._tools.Preview;
  var orig = P.prototype.renderVariantPhotos;

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function loadImg(url) {
    return new Promise(function (resolve, reject) {
      var i = new Image(); i.crossOrigin = 'anonymous';
      i.onload = function () { resolve(i); }; i.onerror = reject; i.src = url;
    });
  }

  /* ---------- read one month photo ---------- */
  function analyse(img, T) {
    var W = img.naturalWidth, H = img.naturalHeight;
    var c = el('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0);
    var d = ctx.getImageData(0, 0, W, H).data;
    function px(x, y) { return (y * W + x) * 4; }
    // background = the middle one of the four corners
    var cs = [px(3, 3), px(W - 4, 3), px(3, H - 4), px(W - 4, H - 4)].map(function (k) { return [d[k], d[k + 1], d[k + 2]]; });
    cs.sort(function (a, b) { return (a[0] + a[1] + a[2]) - (b[0] + b[1] + b[2]); });
    var bg = cs[1];
    T = T || 18;
    function diff(k) { return Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]); }

    // "outside" = background reachable from the edges of the band (its top row counts as an edge, so the
    // open space between the two chain lines is outside too). Everything else is solid, which keeps light
    // parts inside a charm (clear stones, shine) instead of punching holes in it.
    var y0 = Math.floor(H * 0.25), BH = H - y0, N = W * BH;
    var out = new Uint8Array(N), q = new Int32Array(N), qh = 0, qt = 0, x, y;
    // what differs from the background, then closed by a few pixels so open settings (prongs around a clear
    // April stone) still count as one closed charm
    var fg = new Uint8Array(N), tmp = new Uint8Array(N), rad = Math.max(3, Math.round(W / 240));
    for (y = 0; y < BH; y++) for (x = 0; x < W; x++) fg[y * W + x] = diff(px(x, y + y0)) > T ? 1 : 0;
    function spread(src, dst, val, horiz) { // max (val=1) or min (val=0) filter along rows or columns
      var L = horiz ? W : BH, M = horiz ? BH : W;
      for (var m2 = 0; m2 < M; m2++) {
        var cnt = 0, i2;
        function at(l) { return horiz ? m2 * W + l : l * W + m2; }
        for (i2 = 0; i2 < Math.min(rad, L); i2++) if (src[at(i2)] === val) cnt++;
        for (i2 = 0; i2 < L; i2++) {
          if (i2 + rad < L && src[at(i2 + rad)] === val) cnt++;
          if (i2 - rad - 1 >= 0 && src[at(i2 - rad - 1)] === val) cnt--;
          dst[at(i2)] = cnt > 0 ? val : 1 - val;
        }
      }
    }
    var raw = fg.slice();
    spread(fg, tmp, 1, true); spread(tmp, fg, 1, false); spread(fg, tmp, 0, true); spread(tmp, fg, 0, false);
    function isRaw(ix, iy) { return iy >= y0 && raw[(iy - y0) * W + ix] === 1; }
    function seed(ix, iy) { var j = iy * W + ix; if (!out[j] && !fg[j]) { out[j] = 1; q[qt++] = j; } }
    for (x = 0; x < W; x++) { seed(x, 0); seed(x, BH - 1); }
    for (y = 0; y < BH; y++) { seed(0, y); seed(W - 1, y); }
    while (qh < qt) {
      var j = q[qh++], jx = j % W, jy = (j / W) | 0;
      if (jx > 0) seed(jx - 1, jy); if (jx < W - 1) seed(jx + 1, jy);
      if (jy > 0) seed(jx, jy - 1); if (jy < BH - 1) seed(jx, jy + 1);
    }
    function solid(ix, iy) { return iy >= y0 && ix >= 0 && ix < W && !out[(iy - y0) * W + ix]; }
    function runAt(iy, ix) { // solid run in row iy that contains column ix
      if (!solid(ix, iy)) return null;
      var l = ix, r = ix;
      while (l > 0 && solid(l - 1, iy)) l--;
      while (r < W - 1 && solid(r + 1, iy)) r++;
      return [l, r];
    }
    function runs(iy) {
      var res = [], s = -1;
      for (var ix = 0; ix < W; ix++) {
        var o = solid(ix, iy);
        if (o && s < 0) s = ix;
        if (!o && s >= 0) { res.push([s, ix - 1]); s = -1; }
      }
      if (s >= 0) res.push([s, W - 1]);
      return res;
    }
    // lowest part of the charm: walk up its middle until the open space between the chain lines is reached.
    // Thin things below it (a faint shadow, specks) are too short and are skipped.
    var bottom = H - 1, rr = [], cx = 0, spans = {}, top = 0, ph = 0, start = H - 1;
    while (true) {
      for (bottom = start; bottom > y0; bottom--) { rr = runs(bottom).filter(function (r) { return r[1] - r[0] >= 3; }); if (rr.length) break; }
      if (bottom <= y0) throw new Error('no charm found');
      var wide = rr.reduce(function (a, r) { return r[1] - r[0] > a[1] - a[0] ? r : a; }, rr[0]);
      cx = Math.round((wide[0] + wide[1]) / 2);
      // the lowest row can be one prong to the side: walk up once, re-centre on the widest part, walk again
      for (var pass = 0; pass < 2; pass++) {
        spans = {}; top = bottom;
        for (var miss = 0, yy = bottom; yy > y0; yy--) {
          var r1 = runAt(yy, cx) || runAt(yy, cx - 2) || runAt(yy, cx + 2);
          if (!r1) { if (++miss >= 4) break; continue; }
          miss = 0; spans[yy] = r1; top = yy;
        }
        var wr2 = null;
        for (yy = top; yy <= bottom; yy++) if (spans[yy] && (!wr2 || spans[yy][1] - spans[yy][0] > wr2[1] - wr2[0])) wr2 = spans[yy];
        var cx2 = wr2 ? Math.round((wr2[0] + wr2[1]) / 2) : cx;
        if (Math.abs(cx2 - cx) <= 3) break;
        cx = cx2;
      }
      ph = bottom - top;
      if (ph >= H * 0.03) break;
      start = top - 1;
    }
    // fill any row the walk skipped (very light rows) from its neighbours
    for (y = top; y <= bottom; y++) if (!spans[y]) spans[y] = spans[y - 1] || spans[y + 1];
    // drop a faint shadow under the charm (rows with nothing clearly darker than the background)
    while (bottom > top + 10) {
      var mx = 0, sb2 = spans[bottom];
      for (x = sb2[0]; x <= sb2[1]; x++) mx = Math.max(mx, diff(px(x, bottom)));
      if (mx >= 60) break;
      bottom--;
    }
    ph = bottom - top;
    var stoneTop = top, spansOrig = {};
    for (y = top; y <= bottom; y++) spansOrig[y] = spans[y].slice();
    // the bail: the narrowest part of the top 45% of the charm. Rows above it (where the chain runs through
    // the bail) are clipped to the bail's width so no loose chain comes along with the charm
    {
      var neck = top, nw = 1e9;
      for (y = top + 2; y < top + Math.round(ph * 0.45); y++) { var wv = spans[y][1] - spans[y][0]; if (wv < nw) { nw = wv; neck = y; } }
      var bl = spans[neck][0], br = spans[neck][1];
      for (y = top; y < neck; y++) {
        var c3 = Math.round((bl + br) / 2), hw2 = Math.max(4, Math.round((br - bl) / 2 + 2 + (neck - y) * 0.15));
        spans[y] = [Math.max(spans[y][0], c3 - hw2), Math.min(spans[y][1], c3 + hw2)];
      }
      // the bail's centre is where the chain runs through (the bottom row can be off-centre)
      cx = Math.round((bl + br) / 2);
    }
    // body width (widest part of the lower half)
    var x0 = W, x1 = 0, bodyW = 0;
    for (y = top; y <= bottom; y++) {
      var sy = spans[y]; x0 = Math.min(x0, sy[0]); x1 = Math.max(x1, sy[1]);
      if (y > stoneTop + ph * 0.4) bodyW = Math.max(bodyW, sy[1] - sy[0] + 1);
    }
    // the charm on its own, soft only along its outline
    var cw = x1 - x0 + 1, ch = bottom - top + 1;
    function makeCut(yFrom, spanAt) {
      var cv2 = el('canvas'); cv2.width = cw; cv2.height = bottom - yFrom + 1;
      var cc = cv2.getContext('2d'), od = cc.createImageData(cw, cv2.height), o = od.data;
      for (var yq = yFrom; yq <= bottom; yq++) {
        var sp = spanAt(yq);
        for (var xq = Math.max(x0, sp[0]); xq <= Math.min(x1, sp[1]); xq++) {
          var k = px(xq, yq), qn = ((yq - yFrom) * cw + (xq - x0)) * 4;
          o[qn] = d[k]; o[qn + 1] = d[k + 1]; o[qn + 2] = d[k + 2];
          var edge = Math.min(xq - sp[0], sp[1] - xq);
          // inside: solid. Near the outline, background-coloured pixels (gaps the closing bridged) fade out
          o[qn + 3] = edge >= rad + 2 || (edge >= 2 && isRaw(xq, yq)) ? 255 : Math.max(0, Math.min(255, (diff(k) - 4) * 10));
        }
      }
      cc.putImageData(od, 0, 0);
      return cv2;
    }
    var cut = makeCut(top, function (yq) { return spans[yq]; });
    // a tighter version for charms hung straight down: the bail kept to its own width and cut off where the
    // photo's chain runs through it, so no bits of the old chain come along
    var cleanTop = top, bw0 = br - bl;
    for (y = neck; y >= top; y--) if (spansOrig[y][1] - spansOrig[y][0] > bw0 + 2 * rad + 4) { cleanTop = y + 1; break; }
    var cut2 = makeCut(cleanTop, function (yq) {
      return yq < neck ? [Math.max(spansOrig[yq][0], bl - 1), Math.min(spansOrig[yq][1], br + 1)] : spans[yq];
    });
    // centre of the widest part (a round bezel's middle)
    var bodyCx = cx, bwBest = 0;
    for (y = stoneTop + Math.round(ph * 0.4); y <= bottom; y++) if (spans[y][1] - spans[y][0] > bwBest) { bwBest = spans[y][1] - spans[y][0]; bodyCx = (spans[y][0] + spans[y][1]) / 2; }

    // the photo without its charm = the empty chain
    var base = el('canvas'); base.width = W; base.height = H;
    var bx = base.getContext('2d'); bx.drawImage(c, 0, 0);
    bx.fillStyle = 'rgb(' + bg.join(',') + ')';
    for (y = top - 2; y <= Math.min(H - 1, bottom + 4); y++) { var sb = spans[y] || spans[top]; bx.fillRect(sb[0] - 3, y, sb[1] - sb[0] + 7, 1); }

    // the two sides of the chain above the charm: centre of the nearest run on each side, per row
    var left = [], right = [], widths = [];
    for (y = top - 3; y > Math.max(y0 + 2, top - H * 0.62); y -= 2) {
      var rs = runs(y), L = null, R = null;
      for (var m = 0; m < rs.length; m++) {
        if (rs[m][1] < cx) L = rs[m];
        else if (rs[m][0] > cx && !R) R = rs[m];
      }
      if (L) {
        left.push([(L[0] + L[1]) / 2, y]);
        var wr = 0; for (x = L[0]; x <= L[1]; x++) if (isRaw(x, y)) wr++;
        widths.push(wr);
      }
      if (R) right.push([(R[0] + R[1]) / 2, y]);
    }
    widths.sort(function (a, b) { return a - b; });
    var chainW = widths.length ? widths[Math.floor(widths.length * 0.6)] : 8;
    return { W: W, H: H, bg: bg, src: c, base: base, top: top, bottom: bottom, cx: cx, bodyW: bodyW, ch: ch,
      cut: cut, cutX: x0, left: left, right: right, chainW: chainW,
      cut2: cut2, cut2Y: cleanTop - top, bodyCx: bodyCx };
  }

  var cache = {};
  function photo(url, T) {
    var key = url + '|' + (T || '');
    if (!cache[key]) {
      cache[key] = loadImg(url).then(function (img) { return analyse(img, T); });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }
  JM._tools.charmPhoto = photo;

  // straight line x = a·y + b through the chain points between two heights
  function fit(pts, yA, yB) {
    var n = 0, sy = 0, sx = 0, syy = 0, sxy = 0;
    pts.forEach(function (p) { if (p[1] >= yA && p[1] <= yB) { n++; sy += p[1]; sx += p[0]; syy += p[1] * p[1]; sxy += p[0] * p[1]; } });
    if (n < 6) return null;
    var den = n * syy - sy * sy; if (!den) return null;
    var a = (n * sxy - sx * sy) / den;
    return { a: a, b: (sx - a * sy) / n };
  }

  // a straight piece of the chain, laid flat (s along the chain, t across it), background keyed out
  function chainStrip(A, line, yA, yB) {
    var d = A.base.getContext('2d').getImageData(0, 0, A.W, A.H).data, W = A.W, bg = A.bg;
    var ux = line.a, uy = 1, ul = Math.sqrt(ux * ux + 1); ux /= ul; uy /= ul;      // down the chain
    var nx = -uy, ny = ux;                                                          // across it
    var p0x = line.a * yA + line.b, p0y = yA, len = Math.max(20, Math.floor((yB - yA) / uy));
    var th = Math.max(6, Math.round(A.chainW * 0.9 + 3));
    var data = new Uint8ClampedArray(len * (2 * th + 1) * 4), prof = new Float32Array(len), s, t;
    for (s = 0; s < len; s++) for (t = -th; t <= th; t++) {
      var X = p0x + ux * s + nx * t, Y = p0y + uy * s + ny * t;
      var xi = Math.floor(X), yi = Math.floor(Y), fx = X - xi, fy = Y - yi, k = ((t + th) * len + s) * 4;
      if (xi < 0 || yi < 0 || xi >= W - 1 || yi >= A.H - 1) continue;
      for (var c2 = 0; c2 < 3; c2++) {
        var i00 = (yi * W + xi) * 4 + c2;
        data[k + c2] = (d[i00] * (1 - fx) + d[i00 + 4] * fx) * (1 - fy) + (d[i00 + W * 4] * (1 - fx) + d[i00 + W * 4 + 4] * fx) * fy;
      }
      var df = Math.abs(data[k] - bg[0]) + Math.abs(data[k + 1] - bg[1]) + Math.abs(data[k + 2] - bg[2]);
      data[k + 3] = Math.max(0, Math.min(255, (df - 8) * 7));
      prof[s] += data[k + 3];
    }
    // repeat length = a whole number of links, so the copied chain joins up without a seam
    var best = 0, per = 0, mean = 0, lag;
    for (s = 0; s < len; s++) mean += prof[s]; mean /= len;
    for (lag = 8; lag < len / 2; lag++) {
      var acc = 0;
      for (s = 0; s + lag < len; s++) acc += (prof[s] - mean) * (prof[s + lag] - mean);
      acc /= (len - lag);
      if (acc > best) { best = acc; per = lag; }
    }
    var L = per ? Math.floor(len / per) * per : len;
    return { data: data, len: len, L: Math.max(per || 1, L), th: th, per: per || len, uy: uy };
  }

  P.prototype.renderVariantPhotos = function (token) {
    var sc = this.cfg.splitCfg || {}, hang = sc.hang;
    if (!hang || this.split || this.locket) return orig.call(this, token);
    var self = this, urls = [];
    for (var i = 0; i < this.state.count; i++) urls.push(this.variantImage(this.state.metal, this.state.stones[i]));
    if (urls.some(function (u) { return !u; })) return Promise.reject(new Error('missing month photo'));
    var T = hang.threshold || 18;
    function plain() { // one charm, or a photo that can't be read: show the photo itself
      return loadImg(urls[0]).then(function (img) {
        if (token !== self.renderToken) return;
        var cv0 = self.canvas;
        if (!cv0) { cv0 = self.canvas = el('canvas', 'jmlp__canvas', { role: 'img' }); self.stage.insertBefore(cv0, self.layersEl); }
        cv0.width = img.naturalWidth; cv0.height = img.naturalHeight;
        cv0.getContext('2d').drawImage(img, 0, 0);
        var s0 = cv0.height * 0.55;
        self.focus = { x: (cv0.width - s0) / 2, y: cv0.height - s0 - cv0.height * 0.05, s: s0 };
        self.paintCopies();
        self.stage.classList.add('jmlp__stage--canvas');
      });
    }
    if (urls.length === 1) return plain();
    return Promise.all(urls.map(function (u) { return photo(u, T); })).then(function (parts) {
      if (token !== self.renderToken) return;
      // photos framed a little differently (e.g. one month shot smaller): bring every charm to the typical size,
      // and take the chain from a typical photo
      var ws = parts.map(function (p) { return p.bodyW; }).sort(function (a1, b1) { return a1 - b1; });
      var wMed = ws[Math.floor(ws.length / 2)];
      parts.forEach(function (p) { var r1 = wMed / p.bodyW; p.k1 = Math.abs(r1 - 1) > 0.05 && r1 > 0.6 && r1 < 1.6 ? r1 : 1; });
      var A = parts.reduce(function (b1, p) { return Math.abs(p.bodyW - wMed) < Math.abs(b1.bodyW - wMed) ? p : b1; }, parts[0]);
      var n = parts.length, W = A.W, H = A.H;
      var cv = self.canvas;
      if (!cv) { cv = self.canvas = el('canvas', 'jmlp__canvas', { role: 'img' }); self.stage.insertBefore(cv, self.layersEl); }
      cv.width = W; cv.height = H;
      cv.setAttribute('aria-label', self.recipe().stones.map(function (s) { return s.label; }).join(', '));
      var x = cv.getContext('2d');

      function drawCharm(p, ax, ay, rot) { // the charm's bail top-centre goes to (ax, ay)
        x.save(); x.translate(ax, ay); x.rotate(rot); if (p.k1 !== 1) x.scale(p.k1, p.k1);
        x.drawImage(p.cut, -(p.cx - p.cutX), 0);
        x.restore();
      }
      function finish(pos2, hh) { // close-up square around the charms as drawn
        var bx0 = 1e9, bx1 = -1e9, by0 = 1e9, by1 = -1e9;
        pos2.forEach(function (q3) { bx0 = Math.min(bx0, q3.ax); bx1 = Math.max(bx1, q3.ax); by0 = Math.min(by0, q3.ay); by1 = Math.max(by1, q3.ay + hh); });
        var fs = Math.min(W, Math.max(bx1 - bx0 + wMed * 3, (by1 - by0) * 1.9, H * 0.42));
        var fcx = (bx0 + bx1) / 2, fcy = (by0 + by1) / 2 - fs * 0.05;
        self.focus = { x: Math.max(0, Math.min(W - fs, fcx - fs / 2)), y: Math.max(0, Math.min(H - fs, fcy - fs / 2)), s: fs };
        self.paintCopies();
        self.stage.classList.add('jmlp__stage--canvas');
      }


      // ---- charms hanging straight down, close together where the chain dips (Grace), or round bezels linked
      // side by side in a gentle row (Solitaire Bezel). The photo's own chain is kept as it is; only a short
      // piece is redrawn, from whole links, so nothing gets stretched.
      function straight() {
        var cw0 = A.chainW, yTop, pts = [], i3;
        function lineX(l, yq) { return l.a * yq + l.b; }
        function lineY(l, xq) { return (xq - l.b) / l.a; }
        x.drawImage(A.base, 0, 0);
        if (hang.mode === 'row') {
          // round bezels joined edge to edge along a soft curve; the chain meets the two end bezels
          var D = wMed, r = D / 2, q = (hang.gap || 1.0) * D;
          var cyB = A.bottom - A.bodyW / 2, cxB = A.bodyCx, phiA = 0.85;
          for (var yy3 = cyB - r; yy3 < cyB; yy3 += 0.5) { // where the chain met the bezel in the photo
            var dx3 = lineX(fl, yy3) - cxB, dy3 = yy3 - cyB;
            if (dx3 * dx3 + dy3 * dy3 <= r * r * 1.02) { phiA = Math.atan2(-dx3, -dy3); break; }
          }
          phiA = Math.max(0.35, Math.min(1.3, phiA));
          var thM = Math.min(hang.curve || 0.45, 0.11 * (n - 1)), Rs = (n - 1) * q / (2 * thM), dl = q / Rs;
          var thm = thM;
          function attach(side) { // the end bezel's chain point, relative to the curve centre
            var th3 = side * thm, ro = -th3 * (hang.turn == null ? 1 : hang.turn);
            var ox = side * r * Math.sin(phiA), oy = -r * Math.cos(phiA);
            return [Rs * Math.sin(th3) + ox * Math.cos(ro) - oy * Math.sin(ro), Rs * Math.cos(th3) + ox * Math.sin(ro) + oy * Math.cos(ro)];
          }
          var aR3 = attach(1), aL3 = attach(-1), cX = apX;
          var cYr = lineY(fr, cX + aR3[0]) - aR3[1], cYl = lineY(fl, cX + aL3[0]) - aL3[1], cY = (cYr + cYl) / 2;
          yTop = Math.min(cY + aR3[1], cY + aL3[1]);
          clearBelow(yTop);
          var pos3 = [];
          for (i3 = 0; i3 < n; i3++) {
            var th4 = (i3 - (n - 1) / 2) * dl;
            pos3.push({ p: parts[i3], k: i3 - (n - 1) / 2, x: cX + Rs * Math.sin(th4), y: cY + Rs * Math.cos(th4), rot: -th4 * (hang.turn == null ? 1 : hang.turn) });
          }
          pos3.forEach(function (q4) { drawDisc(q4.p, q4.x, q4.y, q4.rot, r); });
          return focusOn(pos3.map(function (q4) { return { ax: q4.x, ay: q4.y - r }; }), D);
        }
        // straight-hanging charms: bails side by side, the chain dipping smoothly through them like the
        // reference photos. The new piece of chain starts on the photo's own chain and is made of the very
        // links it replaces, so the joins don't show.
        var g = (hang.gap || 1.06) * wMed, half = (n - 1) * g / 2;
        function trace(list, yq) { // the photo's chain centre at height yq, smoothed over a few rows
          var sx = 0, c5 = 0;
          list.forEach(function (p5) { if (Math.abs(p5[1] - yq) <= 6) { sx += p5[0]; c5++; } });
          return c5 ? sx / c5 : null;
        }
        // join where the chain is wide enough to come down into the outer bails at a slant
        var want = 2 * half + 2 * g * (hang.spread || 0.9), yJ = A.top - 4;
        for (; yJ > A.top - H * 0.45; yJ -= 2) {
          var xl6 = trace(A.left, yJ), xr6 = trace(A.right, yJ);
          if (xl6 != null && xr6 != null && xr6 - xl6 >= want) break;
        }
        var lL = fit(A.left, yJ - 80, yJ + 6) || fl, lR = fit(A.right, yJ - 80, yJ + 6) || fr;
        var sL = chainStrip(A, lL, yJ - 100, yJ), sR = chainStrip(A, lR, yJ - 100, yJ);
        var yP = yJ - Math.max(sL.per, sR.per) * (hang.bend || 1.5);  // the new piece takes over here and bends gently
        var PL = [lineX(lL, yJ), yJ], PR = [lineX(lR, yJ), yJ];
        var midX = (PL[0] + PR[0]) / 2, drop = g * (hang.drop || 0.9), sagV = g * (hang.sag == null ? 0.12 : hang.sag) * (n - 1) / 2;
        var bails = [];
        for (i3 = 0; i3 < n; i3++) {
          var u6 = n > 1 ? (i3 - (n - 1) / 2) / ((n - 1) / 2) : 0;
          bails.push([midX - half + i3 * g, yJ + drop + sagV * (1 - u6 * u6)]);
        }
        function spline(ctrl) { // Catmull-Rom through the control points (first and last only steer)
          var out5 = [];
          for (var c7 = 1; c7 < ctrl.length - 2; c7++) {
            var p0 = ctrl[c7 - 1], p1 = ctrl[c7], p2 = ctrl[c7 + 1], p3 = ctrl[c7 + 2];
            var steps = Math.max(2, Math.ceil(Math.hypot(p2[0] - p1[0], p2[1] - p1[1]) / 2));
            for (var k7 = 0; k7 < steps; k7++) {
              var t7 = k7 / steps, t2 = t7 * t7, t3 = t2 * t7;
              out5.push([0.5 * (2 * p1[0] + (-p0[0] + p2[0]) * t7 + (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 + (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3),
                         0.5 * (2 * p1[1] + (-p0[1] + p2[1]) * t7 + (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 + (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3)]);
            }
          }
          out5.push(ctrl[ctrl.length - 2]);
          return out5;
        }
        // each side is drawn from its own links, from its join down to the bail in the middle (which hides the meeting)
        var mid6 = Math.floor(n / 2), mPt = bails[mid6], after = bails[Math.min(n - 1, mid6 + 1)], before = bails[Math.max(0, mid6 - 1)];
        var pathL = [[lineX(lL, yP - 40), yP - 40], [lineX(lL, yP), yP]].concat(bails.slice(0, mid6), [mPt, after === mPt ? [mPt[0] + g, mPt[1]] : after]);
        var pathR = [[lineX(lR, yP - 40), yP - 40], [lineX(lR, yP), yP]].concat(bails.slice(mid6 + 1).reverse(), [mPt, before === mPt ? [mPt[0] - g, mPt[1]] : before]);
        yTop = yP + 1;
        clearBelow(yTop);
        stamp(sL, spline(pathL), (yP - (yJ - 100)) / sL.uy);
        stamp(sR, spline(pathR), (yP - (yJ - 100)) / sR.uy);
        var pos4 = bails.map(function (b6, i6) { return { p: parts[i6], ax: b6[0], ay: b6[1] }; });
        pos4.forEach(function (q5) { drawHung(q5.p, q5.ax, q5.ay); });
        return focusOn(pos4, Math.max.apply(null, parts.map(function (p) { return (p.ch - p.cut2Y) * p.k1; })));

        function clearBelow(y5) {
          var pad5 = cw0 * 2 + 6;
          var xl5 = Math.min(lineX(fl, H), lineX(fl, y5), lineX(fr, H), lineX(fr, y5)) - pad5 - wMed * n;
          var xr5 = Math.max(lineX(fl, H), lineX(fl, y5), lineX(fr, H), lineX(fr, y5)) + pad5 + wMed * n;
          x.fillStyle = 'rgb(' + A.bg.join(',') + ')';
          x.fillRect(xl5, y5, xr5 - xl5, H - y5);
        }
        function drawHung(p, ax, ay) { // bail centre on the chain line; the bail runs up behind the chain
          var k1 = p.k1, ox = (p.cx - p.cutX), ext = Math.round(cw0 * (hang.bailUp == null ? 0.4 : hang.bailUp));
          x.save(); x.translate(ax, ay - ext * k1); x.scale(k1, k1);
          x.drawImage(p.cut2, 0, 0, p.cut2.width, 2, -ox, 0, p.cut2.width, ext + 1);
          x.drawImage(p.cut2, -ox, ext);
          x.restore();
        }
        function drawDisc(p, cxq, cyq, rot, rr) {
          if (!p.disc) {
            var R0 = p.bodyW / 2 + 1.5, cy0 = p.bottom - p.bodyW / 2, S = Math.ceil(R0 * 2 + 2);
            var dc = el('canvas'); dc.width = dc.height = S;
            var g2 = dc.getContext('2d'); g2.drawImage(p.src, p.bodyCx - S / 2, cy0 - S / 2, S, S, 0, 0, S, S);
            var idd = g2.getImageData(0, 0, S, S), dd = idd.data;
            for (var yy = 0; yy < S; yy++) for (var xx = 0; xx < S; xx++) {
              var dist = Math.sqrt((xx + 0.5 - S / 2) * (xx + 0.5 - S / 2) + (yy + 0.5 - S / 2) * (yy + 0.5 - S / 2));
              var kk2 = (yy * S + xx) * 4, a5 = Math.max(0, Math.min(1, R0 - dist));
              var df5 = Math.abs(dd[kk2] - p.bg[0]) + Math.abs(dd[kk2 + 1] - p.bg[1]) + Math.abs(dd[kk2 + 2] - p.bg[2]);
              if (dist > R0 - 3) a5 = Math.min(a5, Math.max(0, Math.min(1, (df5 - 6) / 30)));
              dd[kk2 + 3] = Math.round(a5 * 255);
            }
            g2.putImageData(idd, 0, 0); p.disc = dc;
          }
          var sc5 = (rr * 2) / p.bodyW;
          x.save(); x.translate(cxq, cyq); x.rotate(rot); x.scale(sc5, sc5);
          x.drawImage(p.disc, -p.disc.width / 2, -p.disc.height / 2);
          x.restore();
        }
        function stamp(st5, path, s0) { // whole links laid along the path, one repeat at a time
          var sc = el('canvas'); sc.width = st5.len; sc.height = 2 * st5.th + 1;
          var sx2 = sc.getContext('2d'), id5 = sx2.createImageData(sc.width, sc.height); id5.data.set(st5.data); sx2.putImageData(id5, 0, 0);
          var per = st5.per, ph5 = ((s0 % per) + per) % per, cum = [0];
          for (var j5 = 1; j5 < path.length; j5++) cum.push(cum[j5 - 1] + Math.hypot(path[j5][0] - path[j5 - 1][0], path[j5][1] - path[j5 - 1][1]));
          var tot = cum[cum.length - 1], seg = 0;
          function at(sv) { while (seg < cum.length - 2 && cum[seg + 1] < sv) seg++; var j6 = seg, f6 = (sv - cum[j6]) / ((cum[j6 + 1] - cum[j6]) || 1);
            return [path[j6][0] + (path[j6 + 1][0] - path[j6][0]) * f6, path[j6][1] + (path[j6 + 1][1] - path[j6][1]) * f6, Math.atan2(path[j6 + 1][1] - path[j6][1], path[j6 + 1][0] - path[j6][0])]; }
          // first piece starts part-way through a link so it carries on from the photo's chain above
          var first = per - ph5, sv = 0;
          while (sv < tot) {
            var lenP = sv === 0 ? Math.max(1, first) : per, mid = at(Math.min(tot, sv + lenP / 2));
            x.save(); x.translate(mid[0], mid[1]); x.rotate(mid[2]);
            x.drawImage(sc, sv === 0 ? ph5 : 0, 0, lenP + 0.8, sc.height, -lenP / 2, -st5.th - 0.5, lenP + 0.8, sc.height);
            x.restore();
            sv += lenP;
          }
        }
        function focusOn(pos5, hh) { finish(pos5, hh); }
      }

      // the two sides of the chain as straight lines, fitted just above the charm
      var yA = A.top - H * 0.32, yB = A.top - H * 0.04;
      var fl = fit(A.left, yA, yB), fr = fit(A.right, yA, yB);
      if (!fl || !fr || fl.a <= fr.a) return plain();
      var apY = (fr.b - fl.b) / (fl.a - fr.a), apX = fl.a * apY + fl.b;              // where the sides would meet
      var aL = Math.atan(fl.a), aR = Math.atan(-fr.a), alpha = (aL + aR) / 2;          // each side's angle from vertical
      if (hang.mode === 'v' || hang.mode === 'row') return straight();
      var phiT = Math.PI / 2 - alpha;                                                  // bottom of the circle → where it meets a side
      var w = Math.max.apply(null, parts.map(function (p) { return p.bodyW * p.k1; })), h = Math.max.apply(null, parts.map(function (p) { return p.ch * p.k1; })), gap = (hang.gap || 1.2) * w;
      // circle touching both sides, just big enough for the charms to sit side by side on its lower part
      var R = Math.max(w * (hang.minR == null ? 1.6 : hang.minR), ((n - 1) * gap + 1.1 * w) / (2 * phiT) - 0.5 * h);
      var cxC = apX, cyC = apY - R / Math.sin(alpha);
      var dphi = gap / (R + 0.5 * h);
      var tL = [cxC - R * Math.cos(aL), cyC + R * Math.sin(aL)], tR = [cxC + R * Math.cos(aR), cyC + R * Math.sin(aR)];

      // empty chain, cleared below the meeting points
      x.drawImage(A.base, 0, 0);
      var yCut = Math.min(tL[1], tR[1]), pad = A.chainW * 2 + 4;
      var xl = Math.min(tL[0], fl.a * H + fl.b, fr.a * H + fr.b) - pad, xr = Math.max(tR[0], fl.a * H + fl.b, fr.a * H + fr.b) + pad;
      x.fillStyle = 'rgb(' + A.bg.join(',') + ')';
      x.fillRect(xl, yCut, xr - xl, H - yCut);

      // chain along the circle, copied from the photo's own links
      var st = chainStrip(A, fl, yA, A.top - H * 0.1);
      var img = x.getImageData(0, 0, W, H), D = img.data, th = st.th;
      var angL = Math.atan2(tL[0] - cxC, tL[1] - cyC), angR = Math.atan2(tR[0] - cxC, tR[1] - cyC); // from straight down
      var bx0 = Math.max(0, Math.floor(tL[0] - th - 2)), bx1 = Math.min(W - 1, Math.ceil(tR[0] + th + 2));
      var by0 = Math.max(0, Math.floor(yCut - th - 2)), by1 = Math.min(H - 1, Math.ceil(cyC + R + th + 2));
      for (var py = by0; py <= by1; py++) for (var pxx = bx0; pxx <= bx1; pxx++) {
        var dx = pxx - cxC, dy = py - cyC, r = Math.sqrt(dx * dx + dy * dy), t = r - R;
        if (t < -th || t > th) continue;
        var ang = Math.atan2(dx, dy);
        if (ang < angL - 0.02 || ang > angR + 0.02) continue;
        var s = Math.round((ang - angL) * R) % st.L; if (s < 0) s += st.L;
        var k = ((Math.round(t) + th) * st.len + s) * 4, a = st.data[k + 3] / 255;
        if (!a) continue;
        var o2 = (py * W + pxx) * 4;
        D[o2] = D[o2] * (1 - a) + st.data[k] * a; D[o2 + 1] = D[o2 + 1] * (1 - a) + st.data[k + 1] * a; D[o2 + 2] = D[o2 + 2] * (1 - a) + st.data[k + 2] * a;
      }
      x.putImageData(img, 0, 0);

      // charms side by side on the lower part of the circle, fanning a little (outer ones first)
      var turn = hang.turn == null ? 0.6 : hang.turn, lift = A.chainW * (hang.lift == null ? 0.9 : hang.lift);
      var pos = parts.map(function (p, i2) {
        var kk = i2 - (n - 1) / 2, phi = kk * dphi;
        return { p: p, k: kk, ax: cxC + (R - lift) * Math.sin(phi), ay: cyC + (R - lift) * Math.cos(phi), rot: -phi * turn };
      });
      pos.slice().sort(function (a2, b2) { return Math.abs(b2.k) - Math.abs(a2.k); }).forEach(function (q2) { drawCharm(q2.p, q2.ax, q2.ay, q2.rot); });
      finish(pos, h);
    }, function () { return plain(); });
  };

  // previews that already started: draw them again
  Object.keys(JM).forEach(function (k) {
    var inst = JM[k], sc = inst && inst.cfg && inst.cfg.splitCfg;
    if (inst && inst.state && inst.photoMode && sc && sc.hang && inst.render) inst.render();
  });
})();
